import React from "react";
import { keyframes, styled } from "@mui/material/styles";

// Glowing border with your specific color cycle
const glowAnimation = keyframes`
  0% {
    box-shadow: 0 0 6px 2px #2BB344;
  }
  25% {
    box-shadow: 0 0 6px 2px #FFC218;
  }
  50% {
    box-shadow: 0 0 6px 2px #E0011C;
  }
  75% {
    box-shadow: 0 0 6px 2px #0BA2FF;
  }
  100% {
    box-shadow: 0 0 6px 2px #2BB344;
  }
`;

const GlowBorder = styled("div")({
  display: "inline-block",
  borderRadius: "27px",
  // padding: "2px", // spacing around the button for glow
  animation: `${glowAnimation} 3s linear infinite`,
});

export default function GlowBorderWrapper({ children }) {
  return <GlowBorder>{children}</GlowBorder>;
}
